import { FORMATTED_SUBCATEGORY_MAP } from '@eventbrite/categories';
import { GenericLazyString } from '@eventbrite/i18n';
import { PARENT_CATEGORY_CONTENT_MAP } from './categoryImages';

interface CategoryContent {
    title: string | GenericLazyString;
    key: string;
    imageUrl: string;
    imageUrlSmall: string;
    subtitle?: string;
    theme?: string;
}

export const CATEGORY_CONTENT_MAP: Record<string, CategoryContent> = {
    ...PARENT_CATEGORY_CONTENT_MAP,
    ...FORMATTED_SUBCATEGORY_MAP,
};
